import { useCallback } from "react"

import { useMatch, useParams } from "react-router-dom"

import { ImageCollectionLayer, ImageSelectedLayer, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { NetworkReferentialLayer, useNavigateToLinearLocation } from "@l2r-front/l2r-networks"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_MIRANDA, API_MODULE_ROADWAY, APP_ROAD } from "../../../../common/constants/appRoad"
import { MODULE_ROADWAY } from "../../../../common/constants/modules"
import {
    DAMAGES_URL_PREFIX_PARAM,
    NETWORK_GRADING_PREFIX_PARAM,
    NETWORK_ASSESMENT_TYPE_URL_PARAM,
    MIRANDA_GRADE_TYPE,
} from "../../../../common/constants/urlParams"
import { DamagesLayer } from "../../containers/DamagesLayer"
import { MirandaNotationLayer } from "../../containers/MirandaNotationLayer"
import { NotationLayer } from "../../containers/NotationLayer"
import { useRoadwayDispatchContext, useRoadwayStateContext } from "../../contexts/RoadwayContext"

export function RoadwayMapLayersRouter() {

    const { getParam } = useUrlParams()
    const match = useMatch(`:slugId/${APP_ROAD}/${MODULE_ROADWAY}/:road`)
    const params = useParams()
    const road = params?.road || params?.["*"]
    const isSegmentView = !!match
    const navigateToLinearLocation = useNavigateToLinearLocation()
    const { setSelectedSegment } = useRoadwayDispatchContext()
    const { setSegmentFeatureIdClicked } = useImageCollectionDispatchContext()
    const { selectedNetworkAssesmentType } = useRoadwayStateContext()

    const currentNetworkAssesmentType = getParam(NETWORK_ASSESMENT_TYPE_URL_PARAM)?.replace(/-(.*)/, "-") || null

    const processNavigation = useCallback((feature, location, navigationOrigin) => {
        if (location && location.road && location.road !== road) {
            setSegmentFeatureIdClicked(feature?.properties?.uuid)
            setSelectedSegment(feature)
            navigateToLinearLocation(location, ".", { saveMapBoundingBox: !isSegmentView, navigationOrigin: navigationOrigin })
        }
    }, [setSegmentFeatureIdClicked, setSelectedSegment, navigateToLinearLocation, isSegmentView, road])

    const displayedModule = selectedNetworkAssesmentType === MIRANDA_GRADE_TYPE ? API_MODULE_MIRANDA : API_MODULE_ROADWAY

    switch (currentNetworkAssesmentType) {
        case DAMAGES_URL_PREFIX_PARAM:
            return (
                <>
                    <NetworkReferentialLayer module={displayedModule} processNavigation={processNavigation} />
                    <DamagesLayer isFocused={!isSegmentView} />
                    {isSegmentView && <ImageCollectionLayer road={road} />}
                    {isSegmentView && <ImageSelectedLayer />}
                </>
            )
        case NETWORK_GRADING_PREFIX_PARAM:
            return (
                <>
                    <NetworkReferentialLayer module={displayedModule} processNavigation={processNavigation} />
                    <NotationLayer />
                    {isSegmentView && <ImageCollectionLayer road={road} />}
                    {isSegmentView && <ImageSelectedLayer />}
                </>
            )
        case MIRANDA_GRADE_TYPE:
            return (
                <>
                    <NetworkReferentialLayer module={displayedModule} processNavigation={processNavigation} />
                    <MirandaNotationLayer />
                    {isSegmentView && <ImageCollectionLayer road={road} />}
                    {isSegmentView && <ImageSelectedLayer />}
                </>
            )
        default:
            return null
    }
}